import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import {
  ColoredText,
  CommonText,
  Container,
  TableText,
  CommonImage,
} from '../../styledComponents/common';
import { TableItem } from '../../styledComponents/teams';
import { CommFirstRoundLetterComp } from '../Teams/CommonComponents';
import {
  TaskLocationsTableHeaderContainer,
  TaskLocationsTableRowContainer,
} from '../TaskLocations/taskLocationsStyles';

import editIcon from '../../assets/img/edit.svg';
import deleteIcon from '../../assets/img/icons/delete.svg'
import DeleteGeofenceModal from './DeleteGeofenceModal';

const GeofenceLocationsTable = ({
  locations,
  loading,
  onEdit,
  onDelete,
  handleShowLocation,
}) => {
  const { t } = useTranslation();
  const [locationToDelete, setLocationToDelete] = useState(null);
  const isManagementViewer = localStorage.getItem('viewer_role') === 'management';


  const handleDeleteClick = (location) => {
    setLocationToDelete(location);
  };

  const confirmDelete = () => {
    if (locationToDelete) {
      onDelete(locationToDelete);
      setLocationToDelete(null);
    }
  };

  const cancelDelete = () => {
    setLocationToDelete(null);
  };

  const getLocationOfficeName = (officeId) => {
    const office = officesShortList.find(office => office.id === officeId);
    return office ? office.name : '-';
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        {loading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <TaskLocationsTableHeaderContainer goefenceTableHeader={true}>
              <TableItem>
                <TableText>{t('location_name')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location_address')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location_type')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('radius')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('location')}</TableText>
              </TableItem>
              {!isManagementViewer && (
                <TableItem>
                  <TableText>{t('actions')}</TableText>
                </TableItem>
              )}
            </TaskLocationsTableHeaderContainer>

            {locations && locations.length > 0 ? (
              locations.map((location, index) => (
                <TaskLocationsTableRowContainer key={location.id} goefenceTableHeader={true}>
                  <TableItem>
                    <CommFirstRoundLetterComp
                      text={location.name}
                      backColor={index}
                      underline={false}
                    />
                  </TableItem>
                  <TableItem>
                    <CommonText>{location.address}</CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>{t(location.type) || '-'}</CommonText>
                  </TableItem>
                  <TableItem>
                    <CommonText>
                      {location.type === 'circular' ? `${location.radius} m` : '-'}
                    </CommonText>
                  </TableItem>
                  <TableItem>
                    <ColoredText
                      type="warning"
                      hover
                      onClick={() => handleShowLocation(location)}
                      fontSize="14px"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('see_location')}
                    </ColoredText>
                  </TableItem>
                  {!isManagementViewer && (
                    <TableItem>
                      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <CommonImage
                          src={editIcon}
                          alt="Edit"
                          size="36px"
                          style={{ cursor: 'pointer' }}
                          onClick={() => onEdit(location)}
                          title={t('edit')}
                        />
                        <CommonImage
                          src={deleteIcon}
                          alt="Delete"
                          size="34px"
                          style={{
                            cursor: 'pointer',
                            border: '1px solid #ef6969',
                            borderRadius: '50%',
                            padding: '8px'
                          }}
                          onClick={() => handleDeleteClick(location)}
                          title={t('delete')}
                        />
                      </div>
                    </TableItem>
                  )}
                </TaskLocationsTableRowContainer>
              ))
            ) : (
              <NoDataComponent
                title={t('no_geofence_locations_found')}
                padding="5vh 0"
                imageHeight="140px"
              />
            )}
          </>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteGeofenceModal
        isOpen={!!locationToDelete}
        toggle={cancelDelete}
        locationToDelete={locationToDelete}
        onConfirmDelete={confirmDelete}
      />
    </Container>
  );
};

export default GeofenceLocationsTable;